// extracted by mini-css-extract-plugin
module.exports = {"description":"VerificationDataAndPersonalization_description__1f7Ec"};